const MFS_PREFIX = 'v2';

export const withMfsDomain = (url: string) => {
  if (window.location.href.includes(MFS_PREFIX)) {
    const urlArr = url.split('/');
    urlArr.splice(1, 0, MFS_PREFIX);

    return urlArr.join('/');
  }

  return url;
};
